import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'

interface OnboardingWrapperProps {
  children: React.ReactNode
  onNext: () => void
  onBack: () => void
  canProceed?: boolean
  nextButtonText?: string
  stepType?: string
  onBeforeNext?: () => Promise<void>
}

const OnboardingWrapper: React.FC<OnboardingWrapperProps> = ({
  children,
  onNext,
  onBack,
  canProceed = true,
  nextButtonText,
  stepType,
  onBeforeNext
}) => {
  const { t } = useTranslation('common')
  const defaultNextText = `${t('navigation.next')} \u2192`
  // Always allow proceeding for now - validation can be added later
  const isStepValid = true

  const handleNext = async () => {
    if (onBeforeNext) {
      try {
        await onBeforeNext()
      } catch (error) {
        console.error('Error in onBeforeNext:', error)
      }
    }
    onNext()
  }

  return (
    <div className="text-center">
      {children}
      
      <div className="flex flex-col sm:flex-row justify-between gap-3 sm:gap-0 max-w-md mx-auto mt-6 px-4">
        <Button
          type="button"
          variant="outline"
          onClick={onBack}
          className="w-full sm:w-auto px-6 py-2 order-2 sm:order-1"
        >
          {t('navigation.back')}
        </Button>

        <Button
          onClick={handleNext}
          disabled={!isStepValid}
          className="w-full sm:w-auto px-6 py-2 bg-gray-800 hover:bg-gray-900 disabled:bg-gray-300 order-1 sm:order-2"
        >
          {nextButtonText || defaultNextText}
        </Button>
      </div>
    </div>
  )
}

export default OnboardingWrapper
